import { action, makeAutoObservable, observable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import {
    VCS_ACCESS_REQUESTS_SETTINGS_STORE_KEY,
    VCS_JOIN_REQUESTS_NOTIFICATIONS_ENABLED_KEY,
    VCS_JOIN_REQUESTS_SOUND_ENABLED_KEY,
} from 'consts';

class AccessRequestsSettingsStore {
    @observable public soundEnabled = localStorage.getItem(VCS_JOIN_REQUESTS_SOUND_ENABLED_KEY) !== '0';
    @observable public notificationsEnabled = localStorage.getItem(VCS_JOIN_REQUESTS_NOTIFICATIONS_ENABLED_KEY) !== '0';

    public constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: VCS_ACCESS_REQUESTS_SETTINGS_STORE_KEY,
            properties: ['soundEnabled', 'notificationsEnabled'],
            storage: window.localStorage,
        });
    }

    @action
    public setSound = (value: boolean): void => {
        this.soundEnabled = value;
    };

    @action
    public setNotifications = (value: boolean): void => {
        this.notificationsEnabled = value;
    };

    @action
    public initFromServer = (settings: {
        vcsAccessRequestsSoundEnabled?: boolean;
        vcsAccessRequestsNotificationsEnabled?: boolean;
    }): void => {
        if (settings.vcsAccessRequestsSoundEnabled !== undefined) {
            this.soundEnabled = settings.vcsAccessRequestsSoundEnabled;
        }
        if (settings.vcsAccessRequestsNotificationsEnabled !== undefined) {
            this.notificationsEnabled = settings.vcsAccessRequestsNotificationsEnabled;
        }
    };
}

export const accessRequestsSettingsStore = new AccessRequestsSettingsStore();
